import { FormFieldType } from 'shared/components'
import { emailValidator } from 'shared/utils'

export const fields: FormFieldType[] = [
  {
    type: 'input',
    label: 'Фамилия',
    placeholder: 'Введите фамилию',
    colClasses: 'col-xs-12 col-sm-6 mb-2',
    name: 'surname',
    maxSize: 50,
    required: true,
  },
  {
    type: 'input',
    label: 'Имя',
    placeholder: 'Введите имя',
    colClasses: 'col-xs-12 col-sm-6 mb-2',
    name: 'name',
    maxSize: 50,
    required: true,
  },
  {
    type: 'input',
    label: 'Компания',
    placeholder: 'Введите название компании',
    colClasses: 'col-xs-12 col-sm-6 mb-2',
    name: 'company',
    required: true,
    maxSize: 50,
  },
  {
    type: 'input',
    placeholder: 'Введите email',
    label: 'E-mail для связи',
    colClasses: 'col-xs-12 col-sm-6 mb-2',
    name: 'email',
    validatorFn: emailValidator,
    required: true,
  },
  {
    type: 'textarea',
    placeholder: 'Опишите кратко, как планируете привлекать подписчиков',
    label: 'Сообщение',
    colClasses: 'col-xs-12 col-sm-12 mb-2',
    name: 'message',
    maxSize: 1000,
    required: true,
  },
]
